import * as React from "react";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
export var SpecialOfferItem = React.memo(function (_a) {
    var item = _a.item;
    if (item.resource === undefined || item.amount === undefined) {
        return React.createElement(React.Fragment, null);
    }
    var icon = getResourceIcon(item.resource);
    var locaKey = item.resource.id === IdResource.Gold
        ? IdLoca.purchaseOffer_bonusGold
        : item.resource.locaKey;
    return (React.createElement("div", { className: IdStyles.LeagueRewardContainer + " special-offer-item" },
        React.createElement("div", { className: "flex flex--spaced w100 h100" },
            React.createElement("div", { className: "special-offer-item__name-icon flex flex--aligned" },
                React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: icon }),
                React.createElement(TextLoca, { id: locaKey, className: IdStyles.TextBoldPrimary + " special-offer-item__name" })),
            React.createElement("div", { className: "special-offer-item__amount flex flex--aligned" },
                React.createElement(NumberFormat, { amount: item.amount, className: IdStyles.TextBoldPrimary })))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/SpecialOfferItem.tsx
// module id = 2952
// module chunks = 3